import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start gap-3 rounded-xl border border-dashed border-line-strong p-6',
        className,
      )}
    >
      {icon && <span className="text-ink-muted">{icon}</span>}
      <div className="flex flex-col gap-1">
        <h3 className="m-0 text-base font-semibold text-ink">{title}</h3>
        {description && <p className="m-0 text-sm text-ink-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}
